import React, { useEffect } from "react";
import { useAuth } from "../context/Auth";

function Dashboard() {
  const { user } = useAuth();
  const { name } = user;

	useEffect(()=>{
		

	})
  return (
    <div>
      <h3>Dashboard</h3>
      <ul>
        User
        <hr />
        <li>Name: {name}</li>
      </ul>
    </div>
  );
}

export default Dashboard;
